module.exports = {
    DELETE_PROJECT: "Are you sure you want to delete {project_name} project?",
    DELETE_PROJECT_MEMBER: "Are you sure you want to delete {user_name} as a project member?",
    PROJECT_BULK_ACTION: "Are you sure you want to perform this action?",
}